import { render, staticRenderFns } from "./DriverEquipmentDetails.vue?vue&type=template&id=56cc5cff&"
import script from "./DriverEquipmentDetails.vue?vue&type=script&lang=js&"
export * from "./DriverEquipmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./DriverEquipmentDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports